import { Block } from "@components/block";
import { EmptyState } from "@components/empty-state";
import { FlexLoader } from "@components/loader";
import { useNotifications } from "@features/notification";
import { Notification } from "@features/notification/api";
import { formatDate, formatTime } from "@helpers/date";
import { useEffect } from "react";
import styles from "./notifications.module.scss";
import { useWebSocket } from "@request/useWebsocket";
import { WebsocketUpdateType } from "@request/websocket";

const messageToUpdate = [WebsocketUpdateType.Notification, WebsocketUpdateType.Withdrawal, WebsocketUpdateType.Appeal]

export const Notifications = () => {
  const { getNotifications, state } = useNotifications();
  const { lastMessage } = useWebSocket();

  useEffect(() => {
    if (lastMessage && messageToUpdate.includes(lastMessage.type)) {
      getNotifications({ limit: 5, page: 1 });
    }
  }, [lastMessage]);

  useEffect(() => {
    getNotifications({ limit: 5, page: 1 });
  }, [getNotifications]);

  return (
    <Block className={styles.notifications}>
      <div className={styles.header}>
        <h3>Последние уведомления</h3>
      </div>

      {state.loading && !state.notifications ? (
        <FlexLoader />
      ) : !state.notifications?.length ? (
        <EmptyState text="Нет уведомлений" className={styles.empty} />
      ) : (
        <ul className={styles.notificationList}>
          {state.notifications.map((notification) => (
            <Item
              key={notification.id}
              title={notification.title}
              created_at={notification.created_at}
            />
          ))}
        </ul>
      )}
    </Block>
  );
};

type ItemProps = Pick<Notification, "created_at" | "title">;

const Item = ({ title, created_at }: ItemProps) => {
  const dateTime = new Date(created_at);

  return (
    <li className={styles.notificationItem}>
      <span className={styles.message}>{title}</span>
      <span className={styles.time}>{formatTime(dateTime)}</span>
      <span className={styles.date}>{formatDate(dateTime, "dd.MM.yyyy")}</span>
    </li>
  );
};
